import { render } from "./BrandOrder.vue?vue&type=template&id=70c35914&scoped=true&ts=true"
import script from "./BrandOrder.vue?vue&type=script&lang=ts"
export * from "./BrandOrder.vue?vue&type=script&lang=ts"

import "./BrandOrder.vue?vue&type=style&index=0&id=70c35914&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c35914"]])

export default __exports__